import { axiosAction } from '../../utils/axiosAction';
import { constructSearchObj } from '../../utils/utils';
import {
  COMMODITIES_CLEAR_COMMODITIES,
  COMMODITIES_CLEAR_PROFILE_TO_EDIT,
  COMMODITIES_CLEAR_SINGLE_COMMODITY,
  COMMODITIES_FETCH_COMMODITIES,
  COMMODITIES_FETCH_COMMODITIES_CATALOG,
  COMMODITIES_FETCH_COMMODITY_GROUPS,
  COMMODITIES_FETCH_PROFILES,
  COMMODITIES_FETCH_SINGLE_COMMODITY,
  COMMODITIES_POST_PROFILE,
  COMMODITIES_SET_EDITED_PROFILE,
  COMMODITIES_SET_PROFILE_TO_EDIT,
  COMMODITY_CATEGORIES_FETCH,
  COMMODITY_SUBCATEGORIES_FETCH,
  COMMODITY_TRANSLATIONS,
  COMMODITY_TRANSLATIONS_UPDATE,
} from '../action-types/commodity-groups-types';

const COMMODITIES_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_COMMODITIES_ENDPOINT}`;
const PRODUCT_PROFILES_RESOURCE = `product-profiles`;
const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_COMMODITY_GROUPS}`;
const ENDPOINT_COMMODITY_TRANSLATIONS = `${process.env.REACT_APP_ENDPOINT_COMMODITY_TRANSLATION_ENDPOINT}`;
const COMMODITIES = `commodities`;
const ENDPOINT_COMMODITY_CATEGORIES = `${process.env.REACT_APP_ENDPOINT_COMMODITY_CATEGORIES}`;
const BELOW_DEFAULT_TEMPERATURE_OPTIONS = {
  handledErrorCode: 'TEMPERATURE_MIN_LOWER_THAN_DEFAULT',
};

export const setCommodityProfileToEdit = payload => ({
  type: COMMODITIES_SET_PROFILE_TO_EDIT,
  payload,
});

export const clearProfileToEdit = () => ({
  type: COMMODITIES_CLEAR_PROFILE_TO_EDIT,
});

export const getCommodityProfiles = (commodityId, params) => async dispatch => {
  const endpoint = `${COMMODITIES_ENDPOINT}/${commodityId}/${PRODUCT_PROFILES_RESOURCE}`;
  return axiosAction.get(endpoint, COMMODITIES_FETCH_PROFILES, dispatch, {
    params,
  });
};

export const getCommodityGroups = searchObj => async dispatch => {
  const endpoint = `${ENDPOINT}${constructSearchObj(searchObj)}`;
  return axiosAction.get(
    endpoint,
    COMMODITIES_FETCH_COMMODITY_GROUPS,
    dispatch,
  );
};
export const getCommodities =
  (searchObj, commoditySubType = 0) =>
  async dispatch => {
    const endpoint = `${ENDPOINT}/${commoditySubType}${constructSearchObj(
      searchObj,
    )}`;
    return axiosAction.get(endpoint, COMMODITIES_FETCH_COMMODITIES, dispatch);
  };

export const getSingleCommodity =
  (commoditySubType, idCommodity, params) => async dispatch => {
    const endpoint = `${ENDPOINT}/${commoditySubType}/${COMMODITIES}/${idCommodity}`;
    return axiosAction.get(
      endpoint,
      COMMODITIES_FETCH_SINGLE_COMMODITY,
      dispatch,
      { params },
    );
  };

export const clearSingleCommodity = () => ({
  type: COMMODITIES_CLEAR_SINGLE_COMMODITY,
});

export const clearCommodities = () => ({
  type: COMMODITIES_CLEAR_COMMODITIES,
});

export const postNewProfile =
  (commodityId, newProfile, brand, allowBelowDefaultTemperature = false) =>
  async dispatch => {
    const endpoint = `${COMMODITIES_ENDPOINT}/${commodityId}/${PRODUCT_PROFILES_RESOURCE}?brand=${brand}`;
    const profile = allowBelowDefaultTemperature
      ? { ...newProfile, allowBelowDefaultTemperature: true }
      : newProfile;
    return axiosAction.post(
      endpoint,
      COMMODITIES_POST_PROFILE,
      dispatch,
      profile,
      BELOW_DEFAULT_TEMPERATURE_OPTIONS,
    );
  };

//Edition Logic
export const setEditedProfile =
  (editedProfile, commodityId, brand, allowBelowDefaultTemperature = false) =>
  async dispatch => {
    const endpoint = `${COMMODITIES_ENDPOINT}/${commodityId}/${PRODUCT_PROFILES_RESOURCE}?brand=${brand}`;
    const profile = allowBelowDefaultTemperature
      ? { ...editedProfile, allowBelowDefaultTemperature: true }
      : editedProfile;
    return !profile.id && profile.heatingDefault
      ? axiosAction.post(
          endpoint,
          COMMODITIES_SET_EDITED_PROFILE,
          dispatch,
          profile,
          BELOW_DEFAULT_TEMPERATURE_OPTIONS,
        )
      : axiosAction.put(
          endpoint,
          COMMODITIES_SET_EDITED_PROFILE,
          dispatch,
          profile,
          BELOW_DEFAULT_TEMPERATURE_OPTIONS,
        );
  };
export const getCommodityTranslation =
  (commodityId, brand) => async dispatch => {
    const endpoint = `${ENDPOINT_COMMODITY_TRANSLATIONS}${commodityId}/translations?brand=${brand}`;
    return axiosAction.get(endpoint, COMMODITY_TRANSLATIONS, dispatch);
  };

export const SetCommodityTranslation = item => async dispatch => {
  try {
    dispatch({
      type: COMMODITY_TRANSLATIONS.SUCCESS,
      payload: item,
    });
  } catch ({ response }) {
    // No-op: Default implementation
  }
};

export const UpdateCommodityTranslation =
  (commodityId, brand, translationsValues) => async dispatch => {
    const endpoint = `${ENDPOINT_COMMODITY_TRANSLATIONS}${commodityId}/translations?brand=${brand}`;
    return axiosAction.put(endpoint, COMMODITY_TRANSLATIONS_UPDATE, dispatch, {
      translations: translationsValues,
    });
  };

export const getCommoditiesCatalog =
  (searchObj, commoditySubType = 0) =>
  async dispatch => {
    const endpoint = `${ENDPOINT}${constructSearchObj(searchObj)}`;
    return axiosAction.get(
      endpoint,
      COMMODITIES_FETCH_COMMODITIES_CATALOG,
      dispatch,
    );
  };

export const getCommodityCategories = brand => async dispatch => {
  const endpoint = `${ENDPOINT_COMMODITY_CATEGORIES}${constructSearchObj({
    brand,
    category: 1,
  })}`;
  return axiosAction.get(endpoint, COMMODITY_CATEGORIES_FETCH, dispatch);
};

export const getCommoditySubcategories = brand => async dispatch => {
  const endpoint = `${ENDPOINT_COMMODITY_CATEGORIES}${constructSearchObj({
    brand,
    category: 0,
  })}`;
  return axiosAction.get(endpoint, COMMODITY_SUBCATEGORIES_FETCH, dispatch);
};
